export default "__VITE_ASSET__c2ed5877__"